const ChatH24Badge = () => (
    <span className="pointer-events-none absolute -right-1.5 -top-2.5 z-10 inline-flex items-center gap-1 rounded-full border border-white bg-[#16A34A] px-2 py-0.5 text-[10px] font-black leading-none text-white shadow-md shadow-[#16A34A]/20 ring-1 ring-[#16A34A]/20">
        <span className="h-1.5 w-1.5 rounded-full bg-white" />
        H24
    </span>
);

export default ChatH24Badge;
